import {TestCard} from '@esgi/main/kits/test-results-panel';
import {styled} from '@esgi/ui/theme';

export const Body = styled(TestCard.Body, {
	display: 'grid',
	gridTemplateColumns: 'auto auto',
	justifyContent: 'space-between',
});
